export default function PageJsonLd() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Person',
        name: 'Алексей Сивко',
        givenName: 'Алексей',
        familyName: 'Сивко',
        jobTitle: 'Бизнес-тренер по продажам, переговорам и развитию руководителей',
        description: 'Практикующий бизнес-тренер, консультант и фасилитатор. Более 18 лет практики в корпоративных продажах, переговорах и развитии руководителей.',
        url: 'https://business-training.by/o-trenere',
        sameAs: [
          'https://sivko.by/',
          'https://t.me/a_sivko'
        ],
        knowsAbout: [
          'Корпоративные тренинги',
          'Обучение продажам',
          'Тренинг переговоров',
          'Развитие руководителей',
          'Soft Skills',
          'Командообразование',
          'Корпоративная академия'
        ],
        worksFor: {
          '@type': 'Organization',
          name: 'Business Training',
          url: 'https://business-training.by'
        }
      },
      {
        '@type': 'Organization',
        name: 'Business Training',
        url: 'https://business-training.by',
        description: 'Корпоративные тренинги, обучение сотрудников, тимбилдинги и бизнес-игры в Минске, Беларуси, России, Казахстане и Израиле.',
        founder: {
          '@type': 'Person',
          name: 'Алексей Сивко'
        },
        areaServed: ['BY', 'RU', 'KZ', 'IL']
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Главная', item: { '@id': 'https://business-training.by/', name: 'Главная' } },
          { '@type': 'ListItem', position: 2, name: 'О тренере', item: { '@id': 'https://business-training.by/o-trenere', name: 'О тренере' } }
        ]
      },
      {
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: 'Кто проводит обучение в Business Training?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Все программы проводит лично Алексей Сивко — практикующий бизнес-тренер с опытом более 18 лет в корпоративных продажах, переговорах и управлении. Автор концепции «Культурология продаж». За плечами — 11 лет работы в Профессиональных Правовых Системах, руководство учебным центром и более 100 корпоративных проектов.'
            }
          },
          {
            '@type': 'Question',
            name: 'Какой опыт у бизнес-тренера Алексея Сивко?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Более 18 лет практики в продажах и переговорах. 100+ корпоративных проектов, 450+ тренингов и стратегических сессий, 4500+ участников. Работал с компаниями из Беларуси, России, Казахстана и Израиля в отраслях: логистика, IT, недвижимость, производство, финансы, медицина, строительство, образование и услуги.'
            }
          },
          {
            '@type': 'Question',
            name: 'Можно ли адаптировать программу обучения под специфику компании?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Да, каждая программа разрабатывается индивидуально. Перед тренингом проводится глубокая диагностика: изучение бизнес-процессов, интервью с руководителями, анализ реальных переговоров и KPI. На основе этих данных программа адаптируется под конкретные задачи и специфику отрасли.'
            }
          },
          {
            '@type': 'Question',
            name: 'Работаете ли вы онлайн с компаниями из других стран?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Да, корпоративные тренинги проводятся как очно, так и онлайн для команд из Беларуси, России, Казахстана, Узбекистана и Израиля. Онлайн-формат включает интерактивные инструменты, разбор реальных кейсов, ролевые игры и практические задания — эффективность не уступает очному обучению.'
            }
          },
          {
            '@type': 'Question',
            name: 'Есть ли сопровождение после тренинга?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Да, посттренинговое сопровождение — обязательная часть системного подхода. Оно включает: регулярные встречи с руководителем, выборочный аудит работы сотрудников, разбор кейсов в Telegram, домашние задания с обратной связью, корректировку инструментов и контроль внедрения. Сопровождение длится от 1 до 6 месяцев.'
            }
          },
          {
            '@type': 'Question',
            name: 'Как проходит диагностика перед обучением?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Диагностика включает: интервью с руководителем и ключевыми сотрудниками, анализ бизнес-процессов и воронки продаж, прослушивание реальных звонков и переписок, изучение текущих KPI и точек падения конверсии. На основе диагностики формируется индивидуальная программа и определяются измеримые цели.'
            }
          },
          {
            '@type': 'Question',
            name: 'Сколько корпоративных проектов реализовано?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Реализовано более 100 корпоративных проектов. Проведено 450+ тренингов и стратегических сессий, обучено 4500+ участников. Среди клиентов — компании из логистики, IT, недвижимости, производства, финансов, медицины, строительства, образования и сферы услуг.'
            }
          },
          {
            '@type': 'Question',
            name: 'С какими компаниями работает Алексей Сивко?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Алексей работает с компаниями B2B и B2C из отраслей: логистика и перевозки, IT и разработка ПО, недвижимость и девелопмент, производство, финансовые услуги и страхование, медицина и фармацевтика, строительство, образование и EdTech, розничная и оптовая торговля, сфера услуг. Программы адаптируются под специфику отрасли и размер компании.'
            }
          }
        ]
      }
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}